import Vue from 'vue';
import Router from 'vue-router';
import { defaultLang } from './locales';
import ListLicenses from './views/ListLicenses.vue';
import store from './store';
import { Action, createForUser } from '@license-manager/casl-rules';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/',
      name: 'listlicenses',
      component: ListLicenses,
      meta: {
        requiresLogin: true,
        casl: { action: Action.Manage, subject: 'AppUser' },
      },
    },
    {
      path: '/edit/:userId?',
      name: 'editlicense',
      component: () =>
        import(
          /* webpackChunkName: "LicenseEditor" */ './views/LicenseEditor.vue'
        ),
      meta: {
        requiresLogin: true,
        casl: { action: Action.Manage, subject: 'AppUser' },
      },
    },
    {
      path: '/usermanagement',
      name: 'usermanagement',
      component: () =>
        import(
          /* webpackChunkName: "UserManagement" */ './views/UserManagement.vue'
        ),
      meta: {
        requiresLogin: true,
        casl: { action: Action.Manage, subject: 'ManagementUser' },
      },
    },
    {
      path: '/customermanagement/:customerId?',
      name: 'customermanagement',
      component: () =>
        import(
          /* webpackChunkName: "CustomerManagement" */ './views/CustomerManagement.vue'
        ),
      meta: {
        requiresLogin: true,
        casl: { action: Action.Manage, subject: 'Customer' },
      },
    },
    {
      path: '/registertan',
      name: 'registertan',
      component: () =>
        import(/* webpackChunkName: "RegisterTan" */ './views/RegisterTan.vue'),
      meta: {
        requiresLogin: true,
        casl: { action: Action.Manage, subject: 'RegisterTan' },
      },
    },
    {
      path: '/permissionmanagement',
      name: 'permissionmanagement',
      component: () =>
        import(
          /* webpackChunkName: "RegisterTan" */ './views/PermissionManagement.vue'
        ),
      meta: {
        requiresLogin: true,
        casl: { action: Action.Manage, subject: 'RegisterTan' },
      },
    },
    {
      path: '/legaltextmanagement',
      name: 'legaltextmanagement',
      component: () =>
        import(/* webpackChunkName: "LegalTexts" */ './views/LegalTexts.vue'),
      meta: {
        requiresLogin: true,
        casl: { action: Action.Manage, subject: 'LegalText' },
      },
    },
    {
      path: '/password/request',
      name: 'requestpassword',
      beforeEnter: (to, from, next) => {
        const userIsLoggedIn = store.getters['user/loggedIn'];
        if (userIsLoggedIn) {
          next({ name: 'listlicenses' });
        } else {
          next();
        }
      },
      component: () => import('./views/passwordreset/RequestNewPassword.vue'),
    },
    {
      path: '/password/setnew/:token',
      name: 'setnewpassword',
      meta: {
        mode: 'manager',
      },
      beforeEnter: (to, from, next) => {
        const userIsLoggedIn = store.getters['user/loggedIn'];
        if (userIsLoggedIn) {
          next({ name: 'listlicenses' });
        } else {
          next();
        }
      },
      component: () => import('./views/passwordreset/SetNewPassword.vue'),
    },
    {
      path: '/app/password/setnew/:token',
      name: 'app:setnewpassword',
      meta: {
        mode: 'app',
      },
      component: () => import('./views/passwordreset/SetNewPassword.vue'),
    },
    {
      path: '/app/confirmregistration/:token',
      name: 'app:confirmregistration',
      meta: {
        mode: 'app',
      },
      component: () => import('./views/AppRegisterConfirm.vue'),
    },
    {
      path: '/appredirect*',
      name: 'app:appredirect',
      component: () => import('./views/AppRedirect.vue'),
    },
    {
      path: '/login',
      name: 'login',
      beforeEnter: (to, from, next) => {
        const userIsLoggedIn = store.getters['user/loggedIn'];
        if (userIsLoggedIn) {
          next({ name: 'listlicenses' });
        } else {
          next();
        }
      },
      component: () => import('./views/Login.vue'),
    },
    { path: '*', redirect: '/' },
  ].map((route) => {
    // add prefix for lang param
    // add languages here
    //route.path = '/:lang(de|en)' + route.path;
    return route;
  }),
});

// redirects to default lang if not set as url param.
router.beforeEach((to, from, next) => {
  //if (!to.params.lang) {
  //next({path: '/' + defaultLang + to.fullPath});
  //} else {
  // handle auth
  const requireLogin = to.meta?.requiresLogin;
  const userIsLoggedIn = store.getters['user/loggedIn'];
  if (requireLogin && !userIsLoggedIn) {
    next({ name: 'login', params: { lang: to.params.lang } });
  } else {
    next();
  }
  //}
});

router.beforeResolve(async (to, from, next) => {
  if (to.meta?.casl) {
    if (!store.state.user.user) {
      await store
        .dispatch('user/refreshJWT')
        .catch((err) => next({ name: 'login' }));
    }
    const CASLUser = store.getters['user/CASLUser'];
    router.app.$ability.update(createForUser(CASLUser).rules);
    const userHasPermissions = router.app.$ability.can(
      to.meta.casl.action,
      to.meta.casl.subject
    );
    userHasPermissions ? next() : next(from.path);
  } else {
    next();
  }
});

router.afterEach((to) => {
  //router.app.$root.$i18n.locale = to.params.lang;
  (<any>router.app).$moment.locale(router.app.$root.$i18n.locale);
});

export default router;
